<template>
  <div class="Payments">
    <h1 class="text-center mb-10">میزان فروش</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <v-card elevation="0" class="mb-4">
          <v-card-title class="justify-center"
            >میزان فروش کل
            <v-chip small class="mr-2">قیمت به تومان است </v-chip>
          </v-card-title>
          <div class="pb-5">
            <h2 class="text-center">{{ discountCodePayments.sum }}</h2>
            <h4 class="text-center">
              از {{ discountCodePayments.count }} خرید
            </h4>
          </div>
        </v-card>
        <v-data-table :headers="headers" :items="Payments" :items-per-page="10">
          <template v-slot:[`item.createDateTime`]="{ item }">
            <persian-date :date="item.createDateTime" />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import NavigationComponent from "./_Navigation.vue";

export default {
  name: "payments-component",
  components: {
    NavigationComponent
  },
  data() {
    return {
      discountCodePayments: null,
      Payments: null,
      headers: [
        { text: "نام مدرسه", value: "school.title", align: "center" },
        { text: "نام مدیر", value: "school.moderator", align: "center" },
        { text: "نوع مدرسه", value: "school.type", align: "center" },
        { text: "استان", value: "school.state", align: "center" },
        { text: "تاریخ خرید", value: "createDateTime", align: "center" },
        { text: "تعداد خرید", value: "discountCodeCount", align: "center" },
        { text: "قیمت پرداختی", value: "totalAmount", align: "center" }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api.get("/Payments/agent").then((res) => {
        this.Payments = res.data.Payments;
        this.discountCodePayments = res.data.sumOfDiscountCodePayments[0];
      });
    }
  }
};
</script>
